module.exports = __webpack_public_path__ + "static/tower-2019-logo-RBG-432471bad1861f0acb511406fa06f96e.png";